<template>
  <div>
    <kst-output print-mode field="DraftNumber" :data="data" :catalog="Catalog"/>
    <kst-output print-mode field="Date" :data="data" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../SlsCatalog.js";

export default {
  props: {
    data: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>